import * as BABYLON from '@babylonjs/core';

import EventBus from "../../tools/event-bus";
import BaseObject from "../BaseObject";

export default class BabylonHotspot extends BaseObject
{
    constructor(scene, name, options)
    {
        super(scene, name, options);
        let self = this;

        // BABYLON.Mesh.CreatePlane
        let plane = BABYLON.Mesh.CreatePlane(this.name, this.options.size, this.scene);
        plane.position = new BABYLON.Vector3(...this.options.position);
        //plane.scaling = 3; //this.options.scaling;
        plane.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;

        plane.material = new BABYLON.StandardMaterial("planeMaterial", this.scene);
        plane.material.diffuseTexture = new BABYLON.Texture("texture/plain.png", this.scene);
        //plane.material.backFaceCulling = false;
        plane.material.diffuseTexture.hasAlpha = true;

        // BABYLON.SpriteManager        
        let hotspotSprite = new BABYLON.SpriteManager("hotspotSprite", "texture/HotspotSprite.png", 10, 256, this.scene);
        let sprite = new BABYLON.Sprite("HotSpot", hotspotSprite);
        sprite.playAnimation(0, 45, true, 40);
        sprite.position = new BABYLON.Vector3(...this.options.position);
        sprite.size = this.options.size;


        this.node = plane;
        this.sprite = sprite;

        if (this.options.trigger)
        {

            this.node.actionManager = new BABYLON.ActionManager(this.scene);
            this.node.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function ()
                {
                    if (self.currentState.infoBox)
                    {
                        // Events entkoppeln, sonst geht mobil der touch up noch in die InfoBox und öffnet dort ggf. ein Bild.
                        window.setTimeout(() => {
                            EventBus.$emit('InfoBox.show', self.currentState.infoBox);
                        }, 500);
                    }
                    else if (self.trigger)
                    {
                        self.trigger();
                    }
                })
            );
        }

        if (!this.options.visible)
        {
            this.hide();
        }

    }

    show()
    {
        super.show();
        this.sprite.isVisible = true;
    }

    hide()
    {
        super.hide();
        this.sprite.isVisible = false;
    }

    setScale(scale)
    {
        super.setScale(scale);
        this.sprite.size = scale;
    }

    initNewState(newState)
    {
        newState = super.initNewState(newState);

        if (typeof newState === 'string')
        {
            newState = {
                visible: true,
                infoBox: newState,
            };
        }

        return newState;
    }

    setPosition(position)
    {
        super.setPosition(position);
        this.sprite.position = position;
    }

}
